import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type {FillObject} from '@PosterWhiteboard/classes/fill.class';

export function useGetKeyFromFillOfTextStylesOfActiveItem<T extends keyof FillObject>(key: T): FillObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];

    if (item && 'textStyles' in item && 'fill' in item.textStyles && item.textStyles.fill[key] !== undefined) {
      return item.textStyles.fill[key];
    }

    return undefined;
  });
}
